var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListBulletIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.875 5.625H16.875M6.875 10H16.875M6.875 14.375H16.875M3.125 5.625H3.13125V5.63125H3.125V5.625ZM3.4375 5.625C3.4375 5.79759 3.29759 5.9375 3.125 5.9375C2.95241 5.9375 2.8125 5.79759 2.8125 5.625C2.8125 5.45241 2.95241 5.3125 3.125 5.3125C3.29759 5.3125 3.4375 5.45241 3.4375 5.625ZM3.125 10H3.13125V10.0063H3.125V10ZM3.4375 10C3.4375 10.1726 3.29759 10.3125 3.125 10.3125C2.95241 10.3125 2.8125 10.1726 2.8125 10C2.8125 9.82741 2.95241 9.6875 3.125 9.6875C3.29759 9.6875 3.4375 9.82741 3.4375 10ZM3.125 14.375H3.13125V14.3813H3.125V14.375ZM3.4375 14.375C3.4375 14.5476 3.29759 14.6875 3.125 14.6875C2.95241 14.6875 2.8125 14.5476 2.8125 14.375C2.8125 14.2024 2.95241 14.0625 3.125 14.0625C3.29759 14.0625 3.4375 14.2024 3.4375 14.375Z",
    stroke: "#3F3F46",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListBulletIcon);
export default __webpack_public_path__ + "static/media/list-bullet-icon.70bc4a8c0888c6c6c4854c0338044225.svg";
export { ForwardRef as ReactComponent };